import axios from 'axios'
import moment from 'moment'

export default {
  state: {
    task: null,
    tasks: [],
  },
  actions: {
    async fetchTasks({ commit, state }, payload) {
      commit('SET_TASKS', [])

      let url = new URL(`${process.env.VUE_APP_TASKS_URL}`)

      Object.keys(payload.params).forEach(key => {
        url.searchParams.set(key, payload.params[key])
      })

      const { data } = await axios.get(url, {
        headers: {
          Authorization: payload.userId,
        },
      })
      if (data.tasks !== null) {
        commit('SET_TASKS', data.tasks)
      }
    },
    async fetchTaskById({ commit, rootState }, { taskId }) {
      commit('SET_TASK', null)

      let url = new URL(`${process.env.VUE_APP_TASKS_URL}`)
      url.searchParams.set('endpoint', 'getbyid')
      url.searchParams.set('id', taskId)

      const { data } = await axios.get(url, {
        headers: {
          Authorization: rootState.user.user.data.uid,
        },
      })
      commit('SET_TASK', data.task)
    },
    async createTask({ rootState, dispatch }, { task }) {
      let url = new URL(`${process.env.VUE_APP_TASKS_URL}?endpoint=create`)

      const adminUser = rootState.user.user.data
      task.createdBy = adminUser.uid

      const { data } = await axios.post(url, task, {
        headers: {
          Authorization: adminUser.uid,
        },
      })

      if (task.claimedBy) await dispatch('notifyUser', { receiverId: task.claimedBy, subject: 'New task assigned', message: 'assigned you a new task', taskId: data.task.id }, { root: true })

      return data.task
    },
    async claimTaskById({ commit, rootState, dispatch }, { taskId }) {
      commit('SET_TASK', null)
      let url = new URL(`${process.env.VUE_APP_TASKS_URL}`)

      url.searchParams.set('endpoint', 'claimbyid')
      url.searchParams.set('id', taskId)

      // prettier-ignore
      const { data: { task } } = await axios.get(url, {
        headers: {
          Authorization: rootState.user.user.data.uid,
        },
      })

      commit('SET_TASK', task)

      if (task.deadlineAt != '0001-01-01T00:00:00.000Z' && task.deadlineAt != '0001-01-01T00:00:00Z') {
        await dispatch('notifyUser', { receiverId: task.createdBy, subject: 'Priority task claimed', message: 'claimed your priority task', taskId: task.id }, { root: true })
      }

      await dispatch('setTaskDeadline', { task })
    },
    async saveTask({ commit, rootState }, { task }) {
      let url = new URL(`${process.env.VUE_APP_TASKS_URL}?endpoint=update`)

      const { data } = await axios.patch(url, task, {
        headers: {
          Authorization: rootState.user.user.data.uid,
        },
      })

      commit('SET_TASK', data.task)
    },
    async unclaimTask({ commit, rootState }, { task }) {
      let url = new URL(`${process.env.VUE_APP_TASKS_URL}?endpoint=unclaimbyid&id=${task.id}`)

      const { data } = await axios.get(url, {
        headers: {
          Authorization: rootState.user.user.data.uid,
        },
      })

      commit('SET_TASK', data.task)
    },
    async deleteTask({ commit, rootState }, taskId) {
      console.log(taskId)
      let url = new URL(`${process.env.VUE_APP_TASKS_URL}`)
      url.searchParams.set('endpoint', 'deleteById')
      url.searchParams.set('id', taskId)

      return await axios.get(url, {
        headers: {
          Authorization: rootState.user.user.data.uid,
        },
      })
    },
    async setTaskDeadline({ dispatch }, { task }) {
      if (task.deadlineAt === '0001-01-01T00:00:00.000Z' || task.deadlineAt === '0001-01-01T00:00:00Z') {
        task.deadlineAt = moment()
          .add(5, 'days')
          .toISOString()

        await dispatch('saveTask', { task })
      }
    },
  },
  mutations: {
    SET_TASKS(state, data) {
      state.tasks = data
    },
    SET_TASK(state, data) {
      state.task = data
    },
  },
  getters: {
    task(state) {
      return state.task
    },
    tasks(state) {
      return state.tasks
    },
    taskDeadline: state => task => {
      if (task.deadlineAt === '0001-01-01T00:00:00.000Z' || task.deadlineAt === '0001-01-01T00:00:00Z') return null
      return task.deadlineAt
    },
  },
}
